import React, { Fragment } from 'react';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import {
  SIMULADOR_RESGATE_PARCIAL,
  SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
} from '../../../utils/paths';

const links = [
  {
    label: 'Simulador do Resgate Parcial',
    to: SIMULADOR_RESGATE_PARCIAL,
    id: 'resgate_parcial',
  },
  {
    label: 'Solicitação do Resgate Parcial',
    to: SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
    id: 'resgate_parcial',
  },
];

export const InstitutosCard = () => {
  const telasAtivas = useSelector((state) => state.telasDisponiveis);

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-32">Institutos</h1>

        {links.map((link) => {
          if (link.id) {
            if (telasAtivas[link.id]) {
              return (
                <Fragment key={link.to}>
                  <hr className="my-4" />
                  <FLink to={link.to} icon>
                    {link.label}
                  </FLink>
                </Fragment>
              );
            }

            return null;
          }

          return (
            <Fragment key={link.to}>
              <hr className="my-4" />
              <FLink to={link.to} icon>
                {link.label}
              </FLink>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
